import gql from 'graphql-tag'

export const APP_ACCESS_QUERY = gql`
  query AppAccess($roles: [String!]!) {
    adminApps(input: { roleNames: $roles }) {
      name
      version
      rootPath
      source
      title
    }
  }
`
